/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Account_Password_SuccessInputs */



/**
* | output |
* | --- |
* | "An email has been sent to you to reset your password" |
*
* @param {My_Account_Password_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const my_account_password_success = /** @type {((inputs?: My_Account_Password_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Account_Password_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("An email has been sent to you to reset your password")
	return /** @type {LocalizedString} */ ("Un email vous a été envoyé pour réinitialiser votre mot de passe")
});